module.exports = __webpack_public_path__ + "img/payment-success-circle.14e51829.svg";